import EVPlugIcon from '~/icons/srp/EVPlugIcon';

type OwnProps = {
  removeDollarSign: boolean;
};

export default function EvPlug({ removeDollarSign }: OwnProps) {
  return (
    <EVPlugIcon
      hollow={removeDollarSign}
      className="absolute h-40 right-[22px] top-[13px] w-40 m:-translate-y-1/2 m:h-[100px] m:right-[34px] m:top-1/2 m:w-[100px]"
    />
  );
}
